import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { motion } from 'framer-motion';
import './faqs.scss';

const Faqs = () => {
  const clientCards = [
  {
    img: '/assets/intone.svg',
    text: 'Reduce manual errors by 90%.',
  },
  {
    img: '/assets/inttwo.svg',
    text: 'Cut task completion time by 75%.',
  },
  {
    img: '/assets/intthree.svg',
    text: 'Achieve compliance with ISO/NIST frameworks.',
  },
  {
    img: '/assets/intfour.svg',
    text: 'Gain enterprise-grade IT management without big budgets.',
  },
];
  return (
    // <section className='main_faqs' id="faqs">
    //   <div className='custom-container'>
    //     <motion.div
    //       className='inner_faqs'
    //       initial={{ opacity: 0, y: 50 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8, ease: 'easeOut' }}
    //       viewport={{ once: false }}
    //     >
    //       {/* Heading */}
    //       <motion.div
    //         className='middle_left'
    //         initial={{ opacity: 0, x: -40 }}
    //         whileInView={{ opacity: 1, x: 0 }}
    //         transition={{ delay: 0.2, duration: 0.6 }}
    //         viewport={{ once: false }}
    //       >
    //         <h2>FAQs</h2>
    //       </motion.div>

    //       {/* Accordion */}
    //       <motion.div
    //         className='middle_right'
    //         initial={{ opacity: 0, x: 40 }}
    //         whileInView={{ opacity: 1, x: 0 }}
    //         transition={{ delay: 0.4, duration: 0.6 }}
    //         viewport={{ once: false }}
    //       >
    //         <Accordion defaultActiveKey="0">
    //           <Accordion.Item eventKey="0">
    //             <Accordion.Header>
    //               <span>01.</span> What services does TechSecure360 offer?
    //             </Accordion.Header>
    //             <Accordion.Body>
    //               We provide end-to-end cybersecurity services including penetration testing, vulnerability assessments, security audits, compliance consulting (ISO, GDPR, HIPAA), and employee awareness training.
    //             </Accordion.Body>
    //           </Accordion.Item>
    //           <Accordion.Item eventKey="1">
    //             <Accordion.Header>
    //               <span>02.</span> Who can benefit from your services?
    //             </Accordion.Header>
    //             <Accordion.Body>
    //               Security is our top priority. We follow best practices, conduct rigorous smart contract audits, and implement robust encryption protocols to ensure all solutions are secure, reliable, and resistant to vulnerabilities.
    //             </Accordion.Body>
    //           </Accordion.Item>
    //           <Accordion.Item eventKey="2">
    //             <Accordion.Header>
    //               <span>03.</span> How often should we conduct a penetration test?
    //             </Accordion.Header>
    //             <Accordion.Body>
    //               Yes! We provide strategic Web3 marketing services, including brand positioning, community engagement, influencer partnerships, social media growth, and performance marketing to help projects gain traction and build a loyal user base.
    //             </Accordion.Body>
    //           </Accordion.Item>
    //           <Accordion.Item eventKey="3">
    //             <Accordion.Header>
    //               <span>04.</span> Do you offer 24/7 support?
    //             </Accordion.Header>
    //             <Accordion.Body>
    //               Our resource augmentation process involves four key steps: consultation, talent matching, onboarding, and ongoing support. We carefully select top-tier Web3 developers, designers, and marketers to seamlessly integrate with your team and scale your project efficiently.
    //             </Accordion.Body>
    //           </Accordion.Item>
    //           <Accordion.Item eventKey="4">
    //             <Accordion.Header>
    //               <span>05.</span> Is our data safe with you during testing?
    //             </Accordion.Header>
    //             <Accordion.Body>
    //               Getting started is simple! Contact us via our website, email, or social media channels. Our team will schedule a consultation to understand your needs and recommend the best solutions for your project.
    //             </Accordion.Body>
    //           </Accordion.Item>
    //         </Accordion>
    //       </motion.div>
    //     </motion.div>
    //   </div>
    // </section>
    <>
  <div className="clients_four_cards">
      <div className="custom-container1">
        <div className="flexnew_div">
          <div>
            <h2>Client Benefits & Outcomes</h2>
            <p>
              Trust us to deliver unmatched reliability, security, and forward-thinking strategies for a future-proof business.
            </p>
          </div>
          <div className="cards_outer">
            {clientCards.map((card, index) => (
              <motion.div
                key={index}
                className="clients_cards"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: '0px 8px 20px rgba(0,0,0,0.1)',
                }}
              >
                <img src={card.img} alt={`card-${index}`} />
                <h4>{card.text}</h4>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Faqs;
